import { atom } from "recoil";

const fromState =atom({
    key: 'from',
    default: ''
})

export default fromState